import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import TproductCrousel from "./TproductCrousel";
import pb3 from "../../../../assets/Home/pots/reminder.png";
import { Link } from "react-router-dom";
import "../../../../Styles/main.css";
import BanquetCrousel from "./BanquetCrousel";
import AllCards from "./AllCards";
import HomeDecor from "../PotsNhomeDecor/HomeDecor";
import Indoor from "../../../../Ecommerce/Shop/Indoor";

const TheTrendings = () => {
  return (
    <Box w={"100%"}>
      <Box m={"auto"} mt={10} textAlign={"left"}>
        <AllCards />
      </Box>
      {/* <Box mt={8}>
        <Link to={"/ComingSoon"}>
          <Image src={pb3} h={{ base: "80px", md: 200 }} w={"100%"} />
        </Link>
      </Box> */}
      <Box>
        <Text
          className="oswald-font"
          fontWeight={"bold"}
          fontSize={{ md: "25px", base: "20px" }}
          color={"#3C375F"}
          letterSpacing={0}
          opacity={1}
        >
          Trending Products
        </Text>
        <Flex mt={5} alignItems={"center"}>
          <Box w={{ md: "100%", base: "100%" }}>
            <TproductCrousel />
          </Box>
        </Flex>
      </Box>
      <Box
        mt={8}
        w={"100%"}
        textAlign={"left"}
        px={10}
        py={5}
        className="indoor_section"
        display={{ md: "block", base: "none" }}
      >
        <Indoor />
      </Box>
      <Box mt={8}>
        <HomeDecor />
      </Box>
      {/* <Box mt={8}>
        <Text
          className="oswald-font"
          fontStyle={"Oswald"}
          fontWeight={"bold"}
          fontSize={{ md: "25px", base: "20px" }}
          color={"#3C375F"}
          letterSpacing={0}
          opacity={1}
        >
          Banquet Hall's
        </Text>
        <Flex mt={5} alignItems={"center"}>
          <Box w={{ md: "100%", base: "100%" }}>
            <BanquetCrousel />
          </Box>
        </Flex>
      </Box> */}
      {/* <Box mt={8}>
        <Flex justifyContent={"space-between"} pr={10} alignItems={"center"}>
          <Text
            className="oswald-font"
            fontStyle={"Oswald"}
            fontWeight={"bold"}
            fontSize={{ md: "25px", base: "20px" }}
            color={"#3C375F"}
            letterSpacing={0}
            opacity={1}
          >
            Corporate Gifting
          </Text>
        </Flex>
        <Flex mt={5} alignItems={"center"}>
          <Box w={{ md: "100%", base: "100%" }}>
            <Link to={"/corporateGifting"}>
              <Image
                src="https://dev.api.wishfy.io/media/public/2023/09/07/17/20230907173733860_wIshFy_ac88f13476334a4090071823ae051118.jpg"
                w={"100%"}
                h={{ base: "80px", md: 200 }}
              />
            </Link>
          </Box>
        </Flex>
      </Box> */}
    </Box>
  );
};

export default TheTrendings;
